
import React from "react";
import MainLayout from "../../components/layout/MainLayout";
import Certificates from "../../components/admin/Certificates";

const AdminCertificates: React.FC = () => {
  return (
    <MainLayout>
      <Certificates />
    </MainLayout>
  );
};

export default AdminCertificates;
